import { Box, IconButton } from "@mui/material";
import ProviderProfile from "../../pages/app/provider/settings/account-setting/ProviderProfile";
import useDisclosure, { DisclosureHost } from "../../hooks/use-disclosure";
import SideSheetDrawer from "../SidesheetDrawer";
import { STATE_LIST } from "../../constants";
import {
  DEFAULT_UUID_NAME_LIST,
  DEFAULT_VALUE_LABEL_LIST,
  getUnNecessaryTransformData,
  transformMultiSelectFrontEndVal,
} from "../../utils/utils";
import UpsertProviderUserDrawer from "./admin/provider-groups/ProviderUserDrawer";
import { useUpdateProviderUser } from "../../queries/use-update-provider-user";
import { ProviderUserType } from "../../constants/ProviderUserSchema";
import { useProvider } from "../../queries/use-provider";
import { useParams } from "react-router-dom";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";

interface ProviderProfileModalProps {
  disClosureHost: DisclosureHost;
  providerUuid: string | null | undefined;
  groupNpiNum?: string;
  profileData?: any;
}

const ProviderProfileDrawer = ({
  disClosureHost,
  providerUuid,
  groupNpiNum,
  profileData,
}: ProviderProfileModalProps) => {
  const { providerGroupId } = useParams();

  const {
    opened: openedProviderUserModal,
    close: closeProviderUserModal,
    open: openProviderUserModal,
  } = useDisclosure(false);
  const { mutateAsync: updateProviderUser } = useUpdateProviderUser();
  const { data, refetch } = useProvider({
    tenantId: providerGroupId,
    providerUuid: providerUuid,
  });
  const providerData: any = data?.data;

  function editProviderUser(values: ProviderUserType) {
    return updateProviderUser({
      providerData: getUnNecessaryTransformData(
        [
          "licensedStates",
          "specialities",
          "acceptedInsurances",
          "workLocations",
        ],
        values
      ) as any,
      xTENANTID: providerGroupId,
    }).then((res) => {
      refetch();
      return res;
    });
  }

  return (
    <SideSheetDrawer
      open={disClosureHost.opened}
      onClose={disClosureHost.close}
      title="View Provider User"
      w="60vw"
      endIcon={
        <IconButton onClick={() => openProviderUserModal()}>
          <ModeOutlinedIcon />
        </IconButton>
      }
    >
      <>
        <UpsertProviderUserDrawer
          open={openedProviderUserModal}
          prefillSpecialtyList={transformMultiSelectFrontEndVal(
            DEFAULT_UUID_NAME_LIST,
            profileData?.specialities
          )?.map((it) => ({ uuid: it?.uuid, name: it?.name }))}
          shouldGetPrefillList
          title={"Edit Provider User"}
          onClose={closeProviderUserModal}
          onSubmit={editProviderUser}
          prefillValues={{
            ...providerData,
            providerType: providerData?.providerType ?? undefined,
            acceptedInsurances: transformMultiSelectFrontEndVal(
              DEFAULT_VALUE_LABEL_LIST,
              providerData?.acceptedInsurances
            ),
            ageGroupSeen: transformMultiSelectFrontEndVal(
              DEFAULT_VALUE_LABEL_LIST,
              providerData?.ageGroupSeen
            ),
            careService: transformMultiSelectFrontEndVal(
              DEFAULT_VALUE_LABEL_LIST,
              providerData?.careService
            ),
            licensedStates: transformMultiSelectFrontEndVal(
              STATE_LIST,
              providerData?.licensedStates
            ),
            spokenLanguages: transformMultiSelectFrontEndVal(
              DEFAULT_UUID_NAME_LIST,
              providerData?.spokenLanguages
            ),
            workLocations: transformMultiSelectFrontEndVal(
              [{ value: "", label: "" }],
              providerData?.workLocations
            ),
            specialities: transformMultiSelectFrontEndVal(
              DEFAULT_UUID_NAME_LIST,
              (providerData as any)?.specialities
            ),
          }}
        />
        <Box width={"60vw"}>
          <ProviderProfile providerData={providerData} groupNpi={groupNpiNum} />
        </Box>
      </>
    </SideSheetDrawer>
  );
};

export default ProviderProfileDrawer;
